import { FETCH_TIMEOUT_DEFAULT, CACHE_TTL_DEFAULT, THROTTLE_WINDOW, REFRESH_TIMEOUT_DEFAULT } from './constants';
import { Configuration } from './interfaces';

export let config = {
    cacheTtl: CACHE_TTL_DEFAULT,
    fetchTimeout: FETCH_TIMEOUT_DEFAULT,
    refreshTimeout: REFRESH_TIMEOUT_DEFAULT,
    throttleWindow: THROTTLE_WINDOW,
    serviceUrl: '',
    appName: '',
    rollouts: [] as string[],
    initialized: false,
};

export const setUserConfiguration = (configuration: Configuration): void => {
    config = {
        ...config,
        ...configuration,
        initialized: true,
    };
};
